<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card title="View Fault">
      <form class="vs-row mb-3 w-full inline-block" autocomplete="off">
        <div class="vx-col md:w-1/4 float-right">
          <vs-input class="w-full" icon-pack="feather" icon="icon-search" name="search" v-model="search" placeholder="Search Vehicle" autocomplete="off" />
        </div>
        <div class="vx-col md:w-1/4 mr-3 float-right">
          <v-select class="w-full" v-model="filter_office_id" :options="offices" label="office_name" index="id" placeholder="Select Office" />
        </div>          
      </form>
      
      <!-- Offline(damaged) vehicle list  -->
      <div class="mb-5 w-full inline-block fault-word-custom">
        <vs-divider position="left" color="danger">
          <h4 class="text-danger p-2">Offline</h4>
        </vs-divider>        
        <vs-table :data="damaged_vehicles" >
          <template slot="thead">
            <vs-th>ID</vs-th>
            <vs-th>Vehicle</vs-th>
            <vs-th sort-key="createdAt">Date</vs-th>
            <vs-th>Time</vs-th>
            <vs-th>Office</vs-th>
            <vs-th>Reported By</vs-th>
            <vs-th>Fault Type</vs-th>
            <vs-th>Status</vs-th>
            <vs-th>Action</vs-th>
          </template>
          <template slot-scope="{data}">              
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.vehical_id.vehical_id }}</vs-td>
              <vs-td>{{ tr.vehical_id.name }} {{ tr.vehical_id.brand }}</vs-td>
              <vs-td>{{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YYYY') }}</vs-td>
              <vs-td>{{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'h:mm a') }}</vs-td>
              <vs-td>{{ tr.vehical_id.office_id.office_name}}</vs-td>
              <vs-td>{{ tr.user_id.firstname+" "+tr.user_id.lastname}}</vs-td>
              <vs-td>
                {{tr.fault_type}}
              </vs-td>
              <vs-td>
                <span v-if="tr.status == 'D'">Damaged</span>
                <span v-else-if="tr.status == 'R'">Repaired</span>
                <span v-else></span>
              </vs-td>
              <vs-td >
                <vs-button
                v-if="tr.status !='R'"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-refresh-ccw"
                  size="small"
                  title="Update Status"
                  @click.stop="confirmUpdateStatus(tr._id)"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <!-- pagiantion block -->
        <div style="height:50px;" v-if="damaged_vehicles.length">
          <div class="float-right mt-5">
            <vs-pagination ref="pagination1" :total="total_page_1" v-model="current_page_1"></vs-pagination>
          </div>
        </div>
      </div>
      <!-- Online(Repaired) vehicle list -->
      <div class="mb-5 w-full inline-block fault-word-custom" >
        <vs-divider position="left" color="success">
          <h4 class="text-success p-2">Online</h4>
        </vs-divider> 
        <vs-table :data="repaired_vehicles">
          <template slot="thead">
            <vs-th>ID</vs-th>
            <vs-th>Vehicle</vs-th>
            <vs-th sort-key="createdAt">Date</vs-th>
            <vs-th>Time</vs-th>
            <vs-th>Office</vs-th>
            <vs-th>Reported By</vs-th>
            <vs-th>Fault Type</vs-th>
            <vs-th>Status</vs-th>
          </template>
          <template slot-scope="{data}">              
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ tr.vehical_id.vehical_id }}</vs-td>
              <vs-td>{{ tr.vehical_id.name }} {{ tr.vehical_id.brand }}</vs-td>
              <vs-td>{{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YYYY') }}</vs-td>
              <vs-td>{{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'h:mm a') }}</vs-td>
              <vs-td>{{ tr.vehical_id.office_id.office_name}}</vs-td>
              <vs-td>{{ tr.user_id.firstname+" "+tr.user_id.lastname}}</vs-td>
              <vs-td>
                {{tr.fault_type}}
              </vs-td>
              <vs-td>
                <span v-if="tr.status == 'D'">Damaged</span>
                <span v-else-if="tr.status == 'R'">Repaired</span>
                <span v-else></span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div style="height:50px;" v-if="repaired_vehicles.length">
          <div class="float-right mt-5">
            <vs-pagination ref="pagination2" :total="total_page_2" v-model="current_page_2"></vs-pagination>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect
  },
  data() {
    return {
      flatID: null,
      damaged_vehicles: [],
      repaired_vehicles: [],
      vehicles: [],
      search:null,
      status_arr: [
        {
          value: "D",
          name: "Damaged"
        },
        {
          value: "R",
          name: "Repaired"
        }
      ],
      per_page_1: 10,
      total_page_1: 1,
      current_page_1: 1,
      per_page_2: 10,
      total_page_2: 1,
      current_page_2: 1,
      filter_office_id: null,
      offices: [],
    };
  },
  watch: {
    current_page_1(nv) {
      if (nv) {
        this.getDamagedVechicle();
      }
    },
    current_page_2(nv) {
      if (nv) {
        this.getRepairedVechicle();
      }
    },
    search(nv) {
      if (nv) {
        if (nv.length >= 3) {
          setTimeout(() => {
            this.searchVehicle();
          }, 200);
        }
      }else{
        this.searchVehicle();
      }
    },
    filter_office_id(){
      this.searchVehicle();
    }
  },
  created() {
    if (
      this.$store.state.uInfo.role !== "CA" &&
      this.$store.state.uInfo.role !== "HR"
    ) {
      history.back();
    }
  },
  mounted() {
    this.getOffice();
    this.getDamagedVechicle();
    this.getRepairedVechicle();
  },
  methods: {
    /** Get all Office */
    getOffice() {
      this.$vs.loading({ color: "primary" });

      let url = "office/getAll";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.offices = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    searchVehicle() {
      this.current_page_1 = 1;
      this.per_page_1 = 10;
      if (this.$refs.pagination1) {
        this.$refs.pagination1.current = 1;
      }
      this.current_page_2 = 1;
      this.per_page_2 = 10;
      if (this.$refs.pagination2) {
        this.$refs.pagination2.current = 1;
      }
      this.getDamagedVechicle();
      this.getRepairedVechicle();
    },

    getVechicle() {
      this.$vs.loading({ color: "primary" });
      
      let url = "vehicalfault";
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.vehicles = data;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    /** Get Damaged vehicle list */
    getDamagedVechicle() {
      this.$vs.loading({ color: "primary" });
      let input = {
        office_id: this.filter_office_id,
        search: this.search,
        status: 'D',
        pageNo: this.current_page_1 - 1,
        pageLimit: this.per_page_1
      };
      let url = "vehicalfault";
      this.axios
        .get(url,{ params: input })
        .then(response => {
          let data = response.data.data;
          this.damaged_vehicles = data.data;
          this.total_page_1 = data.pages;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    /** Get Repaired vehicle list */
    getRepairedVechicle() {
      this.$vs.loading({ color: "primary" });
      let input = {
        office_id: this.filter_office_id,
        search: this.search,
        status: 'R',
        pageNo: this.current_page_2 - 1,
        pageLimit: this.per_page_2
      };
      let url = "vehicalfault";
      this.axios
        .get(url,{ params: input })
        .then(response => {
          let data = response.data.data;
          this.repaired_vehicles = data.data;
          this.total_page_2 = data.pages;
          
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },
    confirmUpdateStatus(id) {
      this.flatID = id;
      this.$vs.dialog({
        type: "confirm",
        title: `Confirm`,
        text: "Are you sure you want to update this Vehicle to available ?",
        acceptText: "Update",
        accept: this.updateStatus
      });
    },
    updateStatus() {
      let input = {
          id: this.flatID
      };
      this.$vs.loading({ color: "primary" });
      this.axios
        .put("vehicalfault", input)
        .then(response => {
          if (response) {   
            this.$vs.loading.close();
            let text = "Vehicle status updated successfully!!!";
            this.$vs.notify({
              text: text,
              color: "success",
              position: "top-right"
            });
            this.flatID = null;
            this.getVechicle();
          }
        })
        .catch(e => {
          this.flatID = null;
          this.showError(e);
        });
    },
  }
};
</script>
<style>

</style>

		